module.exports = __webpack_public_path__ + "static/media/whose.e972da41.png";